import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  filtersTopPerformingRequest: null,
  filtersTopPerformingSuccess: ['result'],
  filtersTopPerformingFailure: ['error'],

  filtersTopPerformingAddToList: ['propName', 'value'],
  filtersTopPerformingRemoveFromList: ['propName', 'value'],
  filtersTopPerformingSet: ['propName', 'value'],

  filtersTopPerformingReset: null,
  filtersTopPerformingFetchingReset: null,
})

export const FiltersTopPerformingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  result: {},
  error: null,
  fetching: false,

  ad_text: null,
  comments_: null,
  platform: [1, 2],
  creative: [1, 2, 3],
  status: [1, 2],
  page_status: [],
  category: [],
  website_provider: [],
  country: [],
  ad_copy_length: [],
  likes: [0, 100000],
  comments: [0, 100000],
  shares: [0, 100000],
  views: [0, 100000],
  price_range: [0, 100000],
})

/* ------------- Selectors ------------- */

export const FiltersSelectors = {
  getFilters: state => state.filtersTopPerforming,
}

/* ------------- Reducers ------------- */

export const filtersTopPerformingRequest = state => {
  //console.log("REDUX filtersRequest req");
  return state.merge({fetching: true, error: null})
}

export const filtersTopPerformingSuccess = (state, {result}) => {
  return state.merge({fetching: false, error: null, result: {filters: result}})
}

export const filtersTopPerformingFailure = (state, {error}) => {
  return state.merge({fetching: false, error})
}

export const filtersTopPerformingFetchingReset = state => {
  return state.merge({fetching: false})
}

export const filtersTopPerformingReset = state => {
  return state.merge({
    ad_text: null,
    comments_: null,
    platform: [1, 2],
    creative: [1],
    status: [1],
    page_status: [],
    category: [],
    website_provider: [],
    country: [],
    ad_copy_length: [],
    likes: [0, 100000],
    comments: [0, 100000],
    shares: [0, 100000],
    views: [0, 100000],
    price_range: [0, 100000],
  })
}

export const filtersTopPerformingAddToList = (state, {propName, value}) => {
  let i = 0
  const list = state[propName]
  const newList = []
  for (i = 0; i < list.length; i++) {
    newList.push(list[i])
  }
  newList.push(value)
  return state.set(propName, newList)
}

export const filtersTopPerformingRemoveFromList = (state, {propName, value}) => {
  let i = 0
  let newList = []
  for (i = 0; i < state[propName].length; i++) {
    if (state[propName][i] === value) continue
    newList.push(state[propName][i])
  }
  return state.set(propName, newList)
}

export const filtersTopPerformingFilterSet = (state, {propName, value}) => {
  /*if(propName === 'tags'){
        return state.merge({tags: value, previousTags: null})
    }*/
  if (Array.isArray(propName)) {
    const data = {}
    for (let i in propName) {
      data[propName[i]] = value[i]
    }

    return state.merge({...data})
  } else {
    return state.set(propName, value)
  }
}

/* ------------- Hookup Reducers To Types ------------- */
//processStatusRequest
export const reducer = createReducer(INITIAL_STATE, {
  [Types.FILTERS_TOP_PERFORMING_REQUEST]: filtersTopPerformingRequest,
  [Types.FILTERS_TOP_PERFORMING_SUCCESS]: filtersTopPerformingSuccess,
  [Types.FILTERS_TOP_PERFORMING_FAILURE]: filtersTopPerformingFailure,

  [Types.FILTERS_TOP_PERFORMING_ADD_TO_LIST]: filtersTopPerformingAddToList,
  [Types.FILTERS_TOP_PERFORMING_REMOVE_FROM_LIST]: filtersTopPerformingRemoveFromList,
  [Types.FILTERS_TOP_PERFORMING_SET]: filtersTopPerformingFilterSet,

  [Types.FILTERS_TOP_PERFORMING_RESET]: filtersTopPerformingReset,

  [Types.FILTERS_TOP_PERFORMING_FETCHING_RESET]: filtersTopPerformingFetchingReset,
})
